interface RouteProps {
  component: React.ComponentClass | React.FunctionComponent;
  props: any;
}

const Route = (props: RouteProps) => React.createElement(props.component, props.props);

export default Route;
